<div class="payment-modal position-relative">
  <button type="button" class="payment-close position-absolute btn-close" (click)="activeModal.dismiss('Cross click')">
  </button>
  <div class="payment-head">
    <h2 class="payment-title mb-3">
      Pay now
    </h2>
  </div>
  <div id="paypal-button" class="mb-3"></div>
  <div id="apple-button"></div>
  <div class="payment-body" id="payment-form-body"></div>
  <div class="payment-disclaimer">

    <!-- <span *ngIf="modalVariant === 'sub'">
    </span>

    <span *ngIf="modalVariant === 'coins'">
    </span> -->

    <span *ngIf="modalVariant === 'coins';else sub_content">
      You will automatically be charged the full price of $9.99. Payments will be charged from the card you specified
      here. By continuing, you indicate that you've read and agree to our <a routerLink="/legal/terms"
        class="text-primblack fw-bold">Terms&nbsp;&&nbsp;Conditions</a>, <a routerLink="/legal/privacy"
        class="text-primblack fw-bold">Privacy&nbsp;Policy</a>, <a routerLink="/legal/money-back"
        class="text-primblack fw-bold">Money
        Back</a> , and <a routerLink="/legal/sub-terms" class="text-primblack fw-bold">Subscription Terms</a>. The
      charge
      will appear on your bill as <span class="fw-bold text-primblack">improvemath.me</span>.
    </span>

    <ng-template #sub_content>
      You will automatically be charged the full price of $9.99/Month You can cancel your subscription by contacting
      the
      support team at <a href="mailto:improvemath.me@supporthelpservice.zendesk.com" class="text-primblack fw-bold">
        improvemath.me@supporthelpservice.zendesk.com
      </a> or via the support chat. Payments will be charged from the card you specified
      here. By continuing, you indicate that you've read and agree to our <a routerLink="/legal/terms"
        class="text-primblack fw-bold">Terms&nbsp;&&nbsp;Conditions</a>, <a routerLink="/legal/privacy"
        class="text-primblack fw-bold">Privacy&nbsp;Policy</a>, <a routerLink="/legal/money-back"
        class="text-primblack fw-bold">Money
        Back</a> , and <a routerLink="/legal/sub-terms" class="text-primblack fw-bold">Subscription Terms</a>. The
      charge
      will appear on your bill as <span class="fw-bold text-primblack">improvemath.me</span>.
    </ng-template>
  </div>
</div>
